import SingleEventPage from "../../components/single-event-page/SingleEventPage";
import PopTheBalloonsImg from "../../assets/event-images/PopTheBalloons.jpg";

const PopTheBallons = {
  image: PopTheBalloonsImg,
  description:
    "Burst into action with this fun and thrilling game! Participants race to pop balloons using only specified methods while competing against the clock and each other.",
    type: "Offline Games",
  eventName: "Pop The Balloons",
  dateTime: "Feb 28 & March 1 , 10:00AM - 04:00PM",
  venue: "IT-207",
  rules: [
    "Participants must only use the tools or methods provided to pop the balloons",
    "No sharp or unauthorized objects are allowed.",
    "Balloons must be popped within the designated play area,stepping out results in disqualification.",
    "The participant who pops the most balloons in the given time wins.",
  ],
  //prize:"Win exciting prizes even more sweeter than your victory",
  firstprize: "Win exciting prizes even more sweeter than your victory",
  secondprize: 0,
  thirdprize: 0,
  contact: [
    {
      name: "Nandhini B",
      phoneNo: "9791647426",
    },
    {
      name: "Ridhumiga C B",
      phoneNo: "8838859600",
    },
  ],
};

const PopTheBalloons = () => {
  return <SingleEventPage eventDetails={PopTheBallons} />;
};

export default PopTheBalloons;
